module.exports = __webpack_public_path__ + "static/img/9.a635df2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/sp/9.png
// module id = kBAT
// module chunks = 0